module.exports = __webpack_public_path__ + "3f704db53badc6d64eb09e7b3ec0e695.pdf";